//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadImg } from "@/api/uploadImg";
import DetailTopPart from "./components/DetailTopPart";
export default {
  name: "FarmingOrderSettleDetail",
  components: {
    DetailTopPart,
  },
  data() {
    return {
      ruleForm: {
        contractId: "",
        orderId: "",
        settleTime: "",
        settleAmout: "",
        remark: "",
        picPaths: [],
      },
      rules: {
        settleTime: [
          {
            required: true,
            message: "请选择支付日期",
            trigger: "change",
          },
        ],
        settleAmout: [
          {
            required: true,
            message: "请输入本次支付金额",
            trigger: "blur",
          },
          //   { type: "number", message: "支付金额为数字类型" },
        ],
        remark: [
          {
            required: true,
            message: "请输入支付说明",
            trigger: "blur",
          },
        ],
        voucherImg: [
          { required: true, message: "请上传支付凭证", trigger: "change" },
        ],
      },
      voucherImg: [],
      fileVoucherImgList: [],
      previewImgUrl: "",
      previeImgVisible: false,
    };
  },
  watch: {
    voucherImg(newValue) {
      let tempAry = [];
      newValue.forEach((item) => {
        // tempAry.push({
        //   fileName: item.name,
        //   picPath: item.url,
        //   fileType: item.type,
        // });
        tempAry.push(item.url);
      });
      this.ruleForm.picPaths = tempAry;
    },
  },
  mounted() {
    let { contractId, orderId } = this.$route.query;
    this.ruleForm.contractId = contractId;
    this.ruleForm.orderId = orderId;
  },
  methods: {
    getParams() {
      return { ...this.ruleForm };
    },
    /**
     * @descripttion: 提交信息
     * @Author: juanjuanhui
     * @Date: 2021-11-17 10:44:50
     * @param {*} formName
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.getParams();
          this.$http.orderSettle.orderSettlementPay(params).then((res) => {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.$router.go(-1);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * @descripttion: 自定义上传图片
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:22:49
     * @param {*} content
     */
    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
        })
        .catch((err) => {
          content.onError(err);
          this.$message.error("服务器异常，请重新上传");
        });
    },
    /**
     * @descripttion: 上传图片成功
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:03
     * @param {*} file
     * @param {*} type
     * @return {*}
     */
    handleImgSuccess(file, type) {
      if (file.status != 111111) {
        this.$message.error(file.message);
        return;
      }
      switch (type) {
        case "voucherImg":
          this[type].push({
            type: 4,
            name: file.title,
            thumb: file.thumb,
            url: file.url,
          });
          break;
      }
    },
    /**
     * @descripttion: 删除图片
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:13
     * @param {*}
     * @return {*}
     */
    handleRemoveImg(file, type) {
      switch (type) {
        case "voucherImg":
          this[type] = this[type].filter((item) => {
            return item.url != file.url;
          });
          break;
      }
    },
    /**
     * @descripttion: 图片改变
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:13
     * @param {*}
     * @return {*}
     */
    handleImgChange(file, type) {
      switch (type) {
        case "voucherImg":
          if (this.voucherImg.length > 0) {
            let { voucherImg, ...data } = this.rules;
            this.rules = data;
            this.$refs.ruleForm.clearValidate("voucherImg");
          } else {
            this.rules.voucherImg = [
              { required: true, message: "请上传支付凭证", trigger: "change" },
            ];
          }
          break;
      }
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-07-08 21:55:27
     * @param {Object} file 视频文件信息
     */
    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },
    /**
     * @descripttion: 图片超出限制
     * @Author: juanjuanhui
     * @Date: 2021-12-14 21:14:02
     * @param {*} files
     * @param {*} fileList
     */
    handleImgExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
